module.exports = __webpack_public_path__ + "img/qrcode_for_gh_55f843d0e539_258.0dad37aa.jpg";